import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';
import { trackPageView } from '../api/admin';

const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

/**
 * usePageTracking — fires a page-view event on each navigation.
 *
 * UUIDs in paths are normalised to `:id` so that e.g.
 * `/wallets/3fa85f64-5717-4562-b3fc-2c963f66afa6` is tracked as
 * `/wallets/:id` — keeping the analytics table clean.
 *
 * Fire-and-forget: errors are swallowed so tracking failures
 * never surface to the user.
 */
export function usePageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    const normalised = location.pathname.replace(UUID_PATTERN, ':id');
    // PostHog page view
    posthog.capture('$pageview', { $current_url: window.location.href, path: normalised });
    // Internal analytics — fire-and-forget, intentionally not awaited
    trackPageView(normalised).catch(() => {
      // Silently ignore; tracking must not disrupt the app
    });
  }, [location.pathname]);
}
